import { Box, IconButton, Stack, TableCell, Tooltip, useTheme } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { PINNED_Z_INDEX, pinnedCellSx } from "lib/@components/managed-columns/pinned-cell-styles"
import { blockDndKey } from "lib/@components/block-dnd-key"
import { SortableItem } from "lib/@components/SortableItem"
import { SortOn } from "routes/asset-register/plugins/regime-display/sort-on"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"

export function AssetViewColumnHeaderCell({ item: column }) {
    const { columnState, pinColumn } = useBoundContext()
    const theme = useTheme()
    const isPinned = columnState?.pinnedField === column.field

    return (
        <SortableItem
            Component={TableCell}
            id={column.field}
            disabled={isPinned}
            align={column.align}
            data-cy={`header-${column.field}`}
            data-col={column.field}
            sx={getCellStyles()}
        >
            <Stack direction="row" alignItems="center" sx={{ width: 1 }}>
                <SortOn field={column.sortField ?? column.field}>{column.label}</SortOn>
                <Box flex={1} />
                <If value={column.pinnable}>
                    <Tooltip title={getPinLabel()}>
                        <IconButton
                            className="col-pin"
                            size="small"
                            onClick={handlePin}
                            onKeyDown={blockDndKey}
                            aria-label={getPinLabel()}
                            data-cy={`pin-column-${column.field}`}
                            sx={{
                                opacity: isPinned ? 1 : 0.2,
                                "&:hover": { opacity: 1, backgroundColor: "transparent" },
                            }}
                        >
                            <Iconify
                                icon={isPinned ? "mdi:pin" : "mdi:pin-outline"}
                                width={24}
                                sx={{ color: isPinned ? "primary.main" : "text.secondary" }}
                            />
                        </IconButton>
                    </Tooltip>
                </If>
            </Stack>
        </SortableItem>
    )

    function getCellStyles() {
        return {
            cursor: "grab",
            zIndex: PINNED_Z_INDEX.header - 1,
            "&:active": { cursor: "grabbing" },
            '& [role="button"]': { cursor: "inherit" },
            ...(isPinned && pinnedCellSx(PINNED_Z_INDEX.header, theme, {})),
        }
    }

    function getPinLabel() {
        return isPinned ? `Unpin ${column.label}` : `Pin ${column.label} to left`
    }

    function handlePin(e) {
        e.stopPropagation()
        pinColumn(column.field)
    }
}
